/**
 * @deprecated please use @website/ui instead
 */
export * from "./lazy-image";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./lazy-image.types";
